module.exports = __webpack_public_path__ + "static/media/circleActiveh.aa298250.svg";